<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-img
        width="20"
        class="mr-1"
        src="@/assets/images/logo/vLogo.png"
      />
      <b-link
        class="ml-35"
        href="#"
        target="_blank"
      >Grupo ViaInvest</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <span class="float-md-right d-none d-sm-inline-block mt-25">
      <a
        target="_blank"
        href="https://www.facebook.com/grupoviainvest"
      ><b-img
        class="ml-2"
        src="@/assets/images/social/face.png"
      /></a>
      <a
        target="_blank"
        href="https://api.whatsapp.com/send?1=pt_BR&phone=551155552144&text=Olá%2C%20Quero%20falar%20com%20um%20especialista"
      ><b-img
        class="ml-2"
        src="@/assets/images/social/zap.png"
      /></a>
      <a
        target="_blank"
        href="https://www.linkedin.com/company/grupoviainvest/"
      ><b-img
        class="ml-2"
        href
        src="@/assets/images/social/linkedin.png"
      /></a>
    </span>
  </p>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BImg,
  },
}
</script>
